import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Loading from "../Loading";
import OnboardingWizard from "../../Containers/Marketplace/OnboardingWizard/OnboardingWizard";

import InfoPopup from "../../Containers/InfoPopup";

import TextArea from "../../Controls/TextArea";

import {
  setOnboardingRequestObject,
  onOnboardingInputChange,
} from "../../Store/onboardingRequestActions";
import {
  setStoreProperty,
  showLoadingScreen,
  hideLoadingScreen,
  hideInfoPopup,
  showInfoPopup,
  showErrorDialog,
} from "../../Store/actions";
import {
  saveOnboardingRequest,
} from "../../http/posts";
import SaveAndContinueConfirm from "../../Containers/Supplier/SaveAndContinueConfirm";
import SuspensionMessageBanner from "./SuspensionMessageBanner/SuspensionMessageBanner";

const mapStateToProps = (state) => ({
  data: state.onboardingRequest,
});

const mapDispatchToProps = (dispatch) => ({
  setMTPLastStep: (onboardingLastStepCompleted) => {
    dispatch(
      setStoreProperty(
        "onboardingLastStepCompleted",
        onboardingLastStepCompleted
      )
    );
  },
  onOnboardingInputChange: (ev) => {
    dispatch(onOnboardingInputChange(ev));
  },
  showLoadingScreen: (msg) => {
    dispatch(showLoadingScreen(msg));
  },
  hideLoadingScreen: () => {
    dispatch(hideLoadingScreen());
  },
  showInfoMsg: (heading, subheading, msgs) => {
    dispatch(showInfoPopup(heading, subheading, msgs));
  },
  hideInfoMsg: () => {
    dispatch(hideInfoPopup());
  },
  updateOnboardingRequest: (onbordingRequest) => {
    dispatch(setOnboardingRequestObject(onbordingRequest));
  },
  showErrorDialog: () => {
    dispatch(showErrorDialog(true));
  },
});

class MTPMotivation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmMsg: false,
    };
  }

  performSave = async (onboardingRequest, saveOnly) => {
    try {
      this.props.showLoadingScreen("saving data...");

      const savedOnboardingRequest = await saveOnboardingRequest(
        onboardingRequest,
        saveOnly
      );
      this.props.updateOnboardingRequest(savedOnboardingRequest);

      this.props.hideLoadingScreen();
    } catch (error) {
      this.props.showErrorDialog();
      this.props.hideLoadingScreen();
      throw error;
    }
  };

  onNextClick = async (nextUrl) => {
    const onboardingRequest = {
      ...this.props.data,
      lastStepCompleted:
        this.props.stepNumber > this.props.data.lastStepCompleted
          ? this.props.stepNumber
          : this.props.data.lastStepCompleted,
    };
    await this.performSave(onboardingRequest, true);
    if (nextUrl.length > 0) {
      this.props.history.push(nextUrl);
    }
  };

  toggleConfirmSaveAndContinue = () => {
    this.setState((prevState) => ({
      showConfirmMsg: !prevState.showConfirmMsg,
    }));
  };

  saveAndContinueLater = async () => {
    await this.performSave(this.props.data, true);
    this.props.history.length = 1;
    this.props.history.replace("/myoffice/onboardingrequest");
  };

  toggleMTPConfirmation = () => {
    this.setState((prevState) => ({
      showMTPConfirmation: !prevState.showMTPConfirmation,
    }));
  };

  toggleManualSupplierConfirmation = () => {
    this.setState((prevState) => ({
      showManualSupplierConfirmationModal: !prevState.showManualSupplierConfirmationModal,
    }));
  };

  componentDidMount() {
    this.props.hideInfoMsg();
  }

  render() {
    return (
      <section id="isuppli-marketplace-motivation">
        {this.state.showConfirmMsg && (
          <SaveAndContinueConfirm
            toggleModalCallback={this.toggleConfirmSaveAndContinue}
            saveAndContinueCallback={this.saveAndContinueLater}
          />
        )}
        <Loading />

        <InfoPopup />

        <OnboardingWizard
          isManualSupplier={this.props.data.manualSupplier}
          currentStep={this.props.stepNumber - 1}
          lastStepCompleted={this.props.data.lastStepCompleted}
          onClickSaveAndContinue={this.toggleConfirmSaveAndContinue}
          onClickNext={this.onNextClick}
          onboardingId={this.props.data.onboardingId}
        >

          <div className="padding-lr-10vw">
            {this.props.onboardingRequest?.suspensionReason
              && (
                <SuspensionMessageBanner suspensionReason={this.props.onboardingRequest?.suspensionReason} />
              )}
            <div className="row top-margin-90px">
              <div className="col-12">
                <div>
                  <h3 className="margin-null">{`STEP 0${this.props.stepNumber}`}</h3>
                </div>
                <div>
                  <h1>MOTIVATION TO ONBOARD:</h1>
                </div>
              </div>

              <div
                className="col-12 justify-center flex-column"
                style={{ paddingTop: "20px" }}
              >
                <h3>
                  What is your motivation for onboarding this supplier company?
                </h3>
              </div>
            </div>

            <div className="row" style={{ paddingTop: "36px" }} />
          </div>

          <section className="padding-lr-10vw">
            <TextArea
              label="Please complete the motivation here:"
              name="motivationToOnboard"
              value={this.props.data.motivationToOnboard}
              onChangeCallback={this.props.onOnboardingInputChange}
            />
          </section>

        </OnboardingWizard>

      </section>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MTPMotivation)
);
